import { Tabs } from "antd";
import ProductList from "./tabItems/ProductList";
import { useEffect, useState } from "react";
import AddProduct from "./tabItems/AddProduct";
import { useDispatch, useSelector } from "react-redux";
import { setProduct } from "../../store/slices/productSlice";
import ProductInventory from "./tabItems/ProductInventory";

export const productTabConfig = {
    PRODUCT_LIST: "1",
    ADD_PRODUCT: "2",
    PRODUCT_INVENTORY: "3"
}

const ProductsTab = () => {
    const [currentTab, setCurrentTab] = useState(productTabConfig.PRODUCT_LIST);
    const [tabData, setTabData] = useState({});
    const dispatch = useDispatch();
    const [tabs, setTabs] = useState([]);


    useEffect(() => {
        dispatch(setProduct({}));
    }, [])

    useEffect(() => {
        const filtered = tabsArray.filter(tb => !tb.hidden)
        setTabs(filtered);
    }, [currentTab])

    const onSwitchTab = (key, data) => {
        setCurrentTab(key);
    } 

    const tabsArray = [
        {
          key: productTabConfig.PRODUCT_LIST,
          label: 'Products',
          children: <ProductList onSwitchTab={onSwitchTab} />,
        },
        {
            key: productTabConfig.ADD_PRODUCT,
            label: 'Add / Modify Product',
            children: <AddProduct onSwitchTab={onSwitchTab} tabProps={{}} />,
        },
        {
            key: productTabConfig.PRODUCT_INVENTORY,
            label: 'Inventory',
            children: <ProductInventory onSwitchTab={onSwitchTab} tabProps={{}} />,
            // disabled: product.id ? false : true,
            hidden: currentTab !== productTabConfig.PRODUCT_INVENTORY
        }
    ];

    const onChange = (key) => {
        setCurrentTab(key);
        if (key !== productTabConfig.ADD_PRODUCT) {
            dispatch(setProduct({}));
        }
    };

    return (
        <div>
            <div className="text-2xl pb-3">Products</div>
            <div className="px-4 border pb-6 bg-white pop-left">

                <Tabs defaultActiveKey="1" activeKey={currentTab} items={tabs} onChange={onChange} />
            </div>
        </div>
    )
}

export default ProductsTab;